import { ExportToCsv } from 'export-to-csv';

export const generateSampleCsv = () => {
  const options = {
    fieldSeparator: ',',
    filename: 'example',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    useTextFile: false,
    useBom: false,
    useKeysAsHeaders: false,
    headers: ['email'],
  };
  const data = [
    {
      email: 'email@example.com',
    },
    {
      email: 'email@example.com',
    },
  ];
  const csvExporter = new ExportToCsv(options);

  csvExporter.generateCsv(data);
};
